import type { CardTypes } from './CreditCart/Icon'
import CreditCard from './CreditCart/Icon'
import { Button, Card, HeaderCard } from '~/design-system/primitives'
import { ChevronRight, CreditCardOff, Delete } from '~/icons'
import { cn } from '~/lib/cn'
import type { AvailableAccount } from '~/type/Cart'
import { EFlagCreditCard } from '~/types/cart.interface'

interface CardListProps {
  availableAccounts: AvailableAccount[]
  getCardDetails: (creditCard: AvailableAccount) => void
  verifyToDeleteCard: (accountId: string) => void
}

export default function CardList({ availableAccounts, getCardDetails, verifyToDeleteCard }: CardListProps) {
  return (
    <>
      <HeaderCard description={'Detalhe do cartão'} icon={<CreditCardOff />} />
      {availableAccounts.map((creditCard: AvailableAccount, index: number) => (
        <Card
          className={cn('flex flex-col lg:w-6/6 m-0 justify-center self-stretch')}
          color="secondary"
          key={index}
        >
          <Card
            className={cn('flex flex-row lg:w-6/6 m-0 p-0 justify-center self-stretch')}
            color="secondary"
          >
            <Card className={cn('flex flex-row lg:w-6/6 p-0 self-stretch')} color="secondary">
              <CreditCard
                cardType={
                  creditCard.paymentSystemName === EFlagCreditCard.AMERICAN_EXPRESS
                    ? 'american-express'
                    : (creditCard.paymentSystemName.toLowerCase() as CardTypes)
                }
              />
              <span className="text-primary-black text-base ml-2">{creditCard.cardNumber}</span>
            </Card>
            <Card className={cn('flex flex-row m-0 p-0 w-auto gap-1 self-stretch')} color="secondary">
              <Button
                className="flex order-3 items-center p-0 m-1"
                onPress={() => verifyToDeleteCard(creditCard.accountId)}
              >
                <Delete className="cursor-pointer" />
              </Button>
              <Button
                className="flex order-3 items-center p-0 m-1"
                onPress={() => getCardDetails(creditCard)}
              >
                <ChevronRight className="cursor-pointer" />
              </Button>
            </Card>
          </Card>
          {creditCard.expired === true && (
            <Card className="flex items-center w-fit gap-0 m-0 flex-row bg-primary-light p-2">
              <CreditCardOff />
              <span className="text-base ml-2 text-primary-black font-normal">Cartão Expirado</span>
            </Card>
          )}
        </Card>
      ))}
    </>
  )
}
